<template>
    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
        <div class="ak-panel__header ak-panel__header--small">
            <div class="ak-panel__title">
                <i class="fa fa-car"></i>
                {{ $t('Te behandelen wagenattesten') }}
            </div>
        </div>
        <div class="ak-panel__body ak-panel__body--small reading">
            <div class="ak-data-table__table table-candidates">
                <table v-if="certificateRequests.length" class="ak-table ak-table--compact ak-panel__table">
                    <thead>
                        <tr class="ak-table-row">
                            <th class="ak-table-head">
                                <span>{{ $t('Datum') }}</span>
                            </th>
                            <th class="ak-table-head">
                                <span>{{ $t('Attest') }}</span>
                            </th>
                            <th class="ak-table-head">
                                <span>{{ $t('Gebruiker') }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody  class="ak-table-body">
                        <tr v-for="(request, index) in certificateRequests" :key="index" class="ak-table-row">
                            <td  v-if="request.status === 0" class="ak-table-column">
                                <span>{{ request.dateCreated | date }}</span>
                            </td>
                            <td  v-if="request.status === 0" class="ak-table-column">
                                <router-link :to="{name: 'car-request-form', params: {hashId: request.hashId}}" class="text-decoration-none">
                                    <span>{{ request.certificate.name }}</span>
                                </router-link>
                            </td>
                            <td  v-if="request.status === 0" class="ak-table-column">
                                <span>{{ request.user.firstName + " " + request.user.surname  }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>
                    {{ $t('Geen nieuwe aanvragen') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CarAttest',
    data() {
        return {
            loading: false,
            certificateRequests: null,
        }
    },
    methods: {
        async getAttests() {
            this.loading = true;
            const result = await this.$get(this.$getSetting('paths.baseCms') + '/car-certificate-requests');
            if (result) {
                this.certificateRequests = result.certificateRequests;
            }

            this.loading = false;
        },
    },
    created() {
        this.getAttests();
        this.path = this.$getSetting('paths.baseCms') + '/grid/car.request'
    }
}
</script>
